import React from 'react';
import { rem } from '../../styles/rem';

import { useBreakpoints } from '../../hooks/useBreakpoints';
import { useIsMobileFirefox } from '../../hooks/useIsMobileFirefox';
import { colors } from '../../styles/colors';
import { FontWeight } from '../../styles/typography';
import LinkViewModel from '../../view-models/LinkViewModel';
import DesktopNavigation from './DesktopNavigation';
import MobileNavigation from './MobileNavigation';
import AlertBanner from '../../components/AlertBanner/AlertBanner';

export type HeaderProps = {
  navigationLinks?: LinkViewModel[];
  serviceMenuLinks?: LinkViewModel[];
  /** Link and aria-label used for the logo (Go back to frontpage) */
  logo?: LinkViewModel;
  alertMessage?: string;
  alertMessageForMobileFirefox?: string;
  loggedIn?: boolean;
};

export const navigationLinkStyle = {
  marginLeft: [0, '20px', '24px', '24px'],
  fontSize: [rem(48), 2, 2],
  fontWeight: [FontWeight.Normal, FontWeight.Medium, FontWeight.Medium],
  lineHeight: [1.16, 1.71],
  color: colors.components.fixedTop.Text.Default,
  textDecoration: 'none',
  borderBottomColor: [
    colors.components.fixedTop.Background.Default,
    'transparent',
  ],
  padding: ['12px 20px', 0],
  transition: 'color .3s ease',
  textAlign: ['center', 'left', 'left'],
  '&:hover': {
    color: colors.components.fixedTop.Text.Default,
    textDecoration: ['none', `underline ${rem(2)}`],
    textUnderlineOffset: rem(5),
  },
};

function Header({
  alertMessage,
  logo,
  navigationLinks,
  serviceMenuLinks,
  alertMessageForMobileFirefox,
  loggedIn,
}: HeaderProps) {
  const [sm] = useBreakpoints();
  const isMobileFirefox = useIsMobileFirefox();
  const showMobileFirefoxAlert =
    !!alertMessageForMobileFirefox && sm === false && isMobileFirefox;

  // Initially we render both mobile and desktop navigation. Once we know the current breakpoint, we can remove the unused view.
  // This is why the `!==` toggle is used - By default it would be `undefined`, until the actual breakpoint state is known.
  return (
    <>
      {sm !== false && (
        <DesktopNavigation
          loggedIn={loggedIn}
          logo={logo}
          navigationLinks={navigationLinks}
          serviceMenuLinks={serviceMenuLinks}
        />
      )}
      {sm !== true && (
        <MobileNavigation
          loggedIn={loggedIn}
          logo={logo}
          navigationLinks={navigationLinks}
          serviceMenuLinks={serviceMenuLinks}
        />
      )}
      {showMobileFirefoxAlert && (
        <AlertBanner message={alertMessageForMobileFirefox} />
      )}
      <AlertBanner message={alertMessage} />
    </>
  );
}

export default Header;
